
























import { defineComponent, reactive, toRefs } from '@vue/composition-api'

import '../node_modules/@fortawesome/fontawesome-free/css/all.css'

export default defineComponent({
    setup(props, context) {
        const data = reactive({
            mail: 'ddjj@aa2000.com.ar',
        })

        const CloseSession = () => {
            sessionStorage.removeItem("UserLogin");
            window.location.href = './'
        }

        return {
            ...toRefs(data),
            ...toRefs(context.root.$store.state),
            CloseSession
        }
    }
});
